import { render } from "./Index.vue?vue&type=template&id=197f5465&bindings={\"notices\":\"props\",\"search_query\":\"props\",\"flash\":\"props\",\"selectedRecord\":\"data\",\"search\":\"options\",\"showDeleteConfirmationModal\":\"options\",\"deleteRecord\":\"options\",\"navigateToEdit\":\"options\"}"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "197f5465"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('197f5465')) {
    api.reload('197f5465', script)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=197f5465&bindings={\"notices\":\"props\",\"search_query\":\"props\",\"flash\":\"props\",\"selectedRecord\":\"data\",\"search\":\"options\",\"showDeleteConfirmationModal\":\"options\",\"deleteRecord\":\"options\",\"navigateToEdit\":\"options\"}", () => {
    api.rerender('197f5465', render)
  })

}

script.__file = "resources/js/Pages/Notices/Index.vue"

export default script